/**
 * @Author: chengzh
 * @Date:   2021-03-10 18:38:18
 * @Last Modified by:   chengzh
 * @Last Modified time: 2021-08-24 16:04:36
 */
import request from '@/utils/request';
import getConfig from 'next/config';
const { publicRuntimeConfig } = getConfig();
// 从环境变量中取MODE，配置在next.config.js和package.json文件中
const mode = publicRuntimeConfig.env.NEXT_PUBLIC_MODE;
// console.log('publicRuntimeConfig', publicRuntimeConfig);
// console.log('mode', mode);

/**
 * 3DS页面获取接口
 * GET
 * @param {*} key
 * @param {*} params
 */
export async function tdsInfo (key) {
  return request(`/api/payment/3ds/info/${key}`);
}

/**
 * 卡bin查询
 * POST
 * /info/cb/{key}
 * Body:encrypted,token
 * encrypted 加密密文，明文内容如：{"cardNo":"745744758475"}
 */
export async function infoCb (key, params) {
  return request(`/api/info/cb/${key}`, {
    method: 'POST',
    body: params,
  });
}

// iframe接口开始
/**
 * 国际信用卡（支付）
 * POST
 * /payment/iframe/icr/payflow/{key}
 * Body:encrypted,token
 * encrypted 加密密文，明文内容如：{"cardNo":"745744758475"}
 * {
 *  "cardId":""
 * "cardBrand":""String",//卡品牌
 * "cardNo":"",
 * "cardName":"",
 * "cardExpirationMonth":"",
 * "cardExpirationYear":"",
 * "cardCvv":"",//持卡有效期-安全码
 * "email":""String",//邮箱
 * "phoneNumber":"", //目前没有
 * "cardCountry":""String",//国籍
 * "cardState":""String",//州or省
 * "cardCity":""String",//城市
 * "cardLine1":""String",//地址1
 * "cardLine2":""String",//地址2
 * "cardPostcode":""String",//用户邮编
 * "publish_key":"String"//订单key
}
 */
export async function paymentIframePayflow (type, key, params) {
  return request(`/api/payment/iframe/${type}/payflow/${key}`, {
    method: 'POST',
    body: params,
  });
}

export async function paymentIframeCard (token, params) {
  return request(`/api/payment/iframe/merchants/card/${token}`, {
    method: 'POST',
    body: params,
  });
}

//iframe绑定卡
export async function iframeCreateCardToken(params) {
  return request(`/api/payment/iframe/merchants/createCardToken`, {
    method: 'POST',
    body: params,
  });
}

//查询卡 bin信息
export async function iframeQueryCardBin(params) {
  return request(`/api/payment/iframe/merchants/queryCardBin`, {
    method: 'POST',
    body: params,
  });
}

//iframe解绑卡
export async function iframeDelCardToken(params) {
  return request(`/api/payment/iframe/merchants/delCardToken`, {
    method: 'POST',
    body: params,
  });
}

//iframe获取pubkey和token
export async function iframeGetAUthKey() {
  return request(`/api/payment/iframe/merchants/getAuthKey`, {
    method: 'GET'
  });
}

/**
 * 国际信用卡订单结果查询
 * GET
 * /payment/iframe/result/{key}
 * key
 */
export async function paymentIframeResult (key) {
  return request(`/api/payment/iframe/result/${key}`, {
    method: 'GET',
  });
}

/**
 * 根据key获取iframe页面信息
 * GET
 * /payment/iframe/icr/info/{key}
 * return publicKey/token/cardBrands
 */
export async function paymentIframeInfo (key) {
  if (mode === 'mock') {
    return request(`/api/iframe/info`);
  }
  return request(`/api/payment/iframe/info/${key}`, {
    method: 'GET',
  });
}


//merchantUrl需要放查询参数的最后一个参数
export async function paymentIframe_2_Info (token, merchantUrl) {
  if (mode === 'mock') {
    return request(`/api/iframe/info`);
  }
  return request(`/api/payment/iframe/merchantInfo/${token}?merchantUrl=${merchantUrl}`, {
    method: 'GET',
  });
}

//根据token获取iframe googlePay信息
export async function iframeGooglePayInfo (token) {
  return request(`/api/payment/iframe/googlepay/info/${token}`, {
    method: 'GET',
  });
}

//根据token获取iframe applePay信息
export async function iframeApplePayInfo(token) {
  return request(`/api/payment/iframe/applepay/info/${token}`, {
    method: 'GET',
  });
}

//Apple Pay PaymentSession验证
// /payment/iframe/validatePaymentSession/49f22dff301d407baf68646f9d37220e
export async function validatePaymentSession(token, params) {
  return request(`/api/payment/iframe/validatePaymentSession/${token}`, {
    method: 'POST',
    body: params,
  });
}

/**
 * 快捷支付（验证并支付）
 * POST
 * /payment/iframe/qpt/validate/{key}
 *
 */
export async function iframeQptValidate (key, params) {
  return request(`/api/payment/iframe/qpt/validate/${key}`, {
    method: 'POST',
    body: params,
  });
}

/**
 * 快捷支付（重新发送短信）
 * POST
 * /payment/iframe/qpt/resend/{key}
 *
 */
export async function iframeQptResend (key, params) {
  return request(`/api/payment/iframe/qpt/resend/${key}`, {
    method: 'POST',
    body: params,
  });
}

/**
 * 订阅初始化信息接口
 * POST
 * /subscription/iframe/info/{key}
 *
 */
export async function subscriptionIframeInfo (key, params) {
  return request(`/api/subscription/iframe/info/${key}`, {
    method: 'GET',
    body: params,
  });
}

/**
 * 订阅更新
 * POST
 * /subscription/iframe/update/{key}
 *
 */
export async function subscriptionIframeUpdate (type, key, params) {
  if (mode === 'mock') {
    return request(`/api/iframe/info`);
  }
  return request(`/api/subscription/iframe/update/${key}`, {
    method: 'POST',
    body: params,
  });
}

/**
 * 3DS页面
 * POST
 * /payment/3ds/info/{key}
 *
 */
export async function payment3dsInfo(key, params) {
  let docRefer = document.referrer

  sessionStorage.getItem('llpayReferrer') ? null : sessionStorage.setItem('llpayReferrer', docRefer);

  if (mode === 'mock') {
    return request(`/api/3ds/info`);
  }
  return request(`/api/payment/3ds/info/${key}`, {
    method: 'GET',
  });
}

/**
 * 设备指纹采集后支付
 * POST
 * /payment/3ds/devicePayflow/{key}
 *
 */
export async function payment3dsDevicePayflow (key, params) {
  if (mode === 'mock') {
    return request(`/api/3ds/devicePayflow`);
  }
  return request(`/api/payment/3ds/devicePayflow/${key}`, {
    method: 'GET',
  });
}

export async function testJson () {
  return request('/test-api/test.json', { method: 'GET' });
}
